import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
import type { Bi } from '../../data/sectors';
import { platformFaq, platformFaqCopy as c } from '../../data/platformFaq';

/* All answers are visible in the HTML (no accordion) so people and answer engines can read them. */
export function PlatformFaq() {
  const {
    lang
  } = useLanguage();
  const pick = (b: Bi) => lang === 'FR' ? b.fr : b.en;
  return <section className="px-6 py-20 lg:py-24 border-t border-[#EEF0F4]" aria-labelledby="platform-faq-title" data-id="element-5583" data-mp="3crwxm863ccwe">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-[0.7fr_1.3fr] gap-10 lg:gap-16" data-id="element-5584" data-mp="3qrogam7jyhgq">
        <div data-id="element-5585" data-mp="3ls214785yr5a">
          <p className="font-sans text-xs font-semibold tracking-[0.22em] uppercase text-[#4F46E5]" data-id="element-5586" data-mp="3lrjxgpj69anc">{pick(c.eyebrow)}</p>
          <h2 id="platform-faq-title" className="mt-4 font-serif text-[2rem] lg:text-[2.4rem] leading-[1.1] tracking-tight text-[#121A3A]" data-id="element-5587" data-mp="15zckjiy2j3t5">
            {pick(c.title)}
          </h2>
        </div>
        <dl className="divide-y divide-[#EEF0F4]" data-id="element-5588" data-mp="3l72h0vsq0n8r">
          {platformFaq.map(f => <div key={f.id} className="py-6 first:pt-0" data-id="element-5589" data-mp="3q4u7dldpw1au">
              <dt data-id="element-5590" data-mp="3v4yq7i23l848">
                <h3 className="font-sans text-[17px] font-semibold text-[#121A3A]" data-id="element-5591" data-mp="3v6jlj9w8kv35">{pick(f.q)}</h3>
              </dt>
              <dd className="mt-2" data-id="element-5592" data-mp="3xvwaiuvknqb">
                <p className="font-sans text-[15px] md:text-[16px] leading-relaxed text-[#4A5168]" data-id="element-5593" data-mp="3wumsitic9ap">{pick(f.a)}</p>
                {f.link && <Link to={f.link.to} className="group mt-3 inline-flex items-center gap-1.5 font-sans text-sm font-medium text-[#4F46E5] hover:text-[#4338CA] transition-colors duration-150" data-id="element-5594" data-mp="37gz1enocjrsa">
                    {pick(f.link.label)}
                    <ArrowRightIcon className="w-3.5 h-3.5 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-5595" data-mp="3h71usozdr7r5" />
                  </Link>}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}